import { render, staticRenderFns } from "./AddTPA.vue?vue&type=template&id=c960f5d6&"
import script from "./AddTPA.vue?vue&type=script&lang=js&"
export * from "./AddTPA.vue?vue&type=script&lang=js&"
import style0 from "./AddTPA.vue?vue&type=style&index=0&id=c960f5d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports